import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskPortalSettingsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-portal-settings',
	path: '/jira/servicedesk/projects/:projectKey/settings/portal-settings/:subPath(portal-groups)?',
	exact: true,
};
